import React, { useEffect, useState } from 'react';

function UserList() {
    const [users, setUsers] = useState([]);

    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const response = await fetch(`${import.meta.env.VITE_REACT_APP_BACK_SPRING_USER_ENDPOINT}/users`);
                console.log('response.status:', response.status);
                if (response.ok) {
                    const data = await response.json();
                    console.log('response data:', JSON.stringify(data));
                    setUsers(data);
                } else {
                    console.log('Error response text:', await response.text());
                }
            } catch (error) {
                console.log('Error:', error);
            }
        };

        fetchUsers();
    }, []);

    return (
        <div>
            <h1>User List</h1>
            <ul>
                {users.map((user) => (
                    <li key={user.id}>
                        User ID: {user.id}<br />
                        EMAIL Adress: {user.email_adress}<br />
                        First Name: {user.first_name} <br />
                        Last Name: {user.last_name} <br />
                        Password: {user.password} <br />
                    </li>
                ))}
            </ul>
        </div>
    );
}

export default UserList;
